<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4"></a>
<h2 class="fmtitle"><a id="page_5"></a>Dedication</h2>
<p class="center1">To my husband and best friend Paul</p>
<p class="center">who is also a great editor and</p>
<p class="center">the most patient person on earth</p>
<p class="center1"><em class="italic">“Let us celebrate the occasion with wine and
            sweet words.”</em> —Plautus</p>
<p class="center1">and to our son</p>
<p class="center">Paul Michael</p>
<p class="center">who <em class="italic">knows</em> his mama’s all out of
            bubblegum!</p>
<p class="center1">And to</p>
<p class="center">Mary Kay and David Baumgartner,</p>
<p class="center">god daughter and god son-in-law</p>
<p class="center">June 19, 2015</p>
<p class="center1">Your lives are a story.</p>
<p class="center">Write a good one.</p>
<p class="center">We love you very much!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?0e253b3e